import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';

import MenuPlan from 'classes/MenuPlan/Detail/MenuPlan';
import Row from 'classes/MenuPlan/Detail/Row';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import InputTranslateButton from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton';
import SimpleInput from 'components/desktop/_general/Input/SimpleInput/SimpleInput';
import clone from 'functions/clone';
import { Language } from 'types/Language/Language';

interface IProps {
	disabled?: boolean;
	entryLanguage: string;
	languages: Language[] | undefined;
	menuPlan: MenuPlan;
	selectedCultureCode: string;
	setMenuPlan: (input: MenuPlan) => void;
}

const RowManagement = (props: IProps) => {
	function handleChangeRowTitle(input: string, rowIndex: number): void {
		const value: string = input;
		props.menuPlan.changeRowTitle(rowIndex, props.selectedCultureCode, value);
		props.setMenuPlan(clone(props.menuPlan));
	}

	async function handleTranslate(rowIndex: number): Promise<void> {
		await props.menuPlan.translateRowTitle(
			rowIndex,
			props.entryLanguage,
			props.selectedCultureCode
		);
		props.setMenuPlan(clone(props.menuPlan));
	}

	const isTranslatable = (): boolean => {
		if (props.disabled) return false;
		if (props.languages) {
			if (props.entryLanguage === props.selectedCultureCode) {
				return false;
			} else {
				return true;
			}
		}
		return false;
	};

	const deleteRow = (row: Row): void => {
		props.menuPlan.removeRow(row);
		props.setMenuPlan(clone(props.menuPlan));
	};

	return (
		<>
			<label>{t('menuPlan:ROWS')}</label>
			{props.menuPlan.rowList.all.map((row: Row, i: number) => {
				return (
					<div className="input-group mb-3" key={i}>
						<SimpleInput
							dataComponentType="menu-plan-line-input"
							dataComponentKey={`${i}`}
							disabled={props.disabled}
							errorKey={`Rows[${i}].NameTranslations`}
							handleChange={(input) => handleChangeRowTitle(input, i)}
							value={row.name?.[props.selectedCultureCode] ?? ''}
						/>
						<button className="btn btn-danger" onClick={() => deleteRow(row)}>
							<FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
						</button>
						<RenderIf condition={isTranslatable()}>
							<InputTranslateButton name="" onClick={() => handleTranslate(i)} />
						</RenderIf>
					</div>
				);
			})}
		</>
	);
};

export default RowManagement;
